export default __webpack_public_path__ + "static/media/cp_geo_aw.1a955653.svg";